export const ETFReturnsMock = {
    exchangeTradedFund: {
        benchmarks: [
            {
                benchmarkCode: 'RUS25',
                benchmarkName: 'Russell 2500 Index',
                benchmarkType: 'Primary',
                __typename: 'ETFBenchmark'
            },
            {
                benchmarkCode: 'LPMCC',
                benchmarkName: 'Lipper Mid-Cap Core Funds Index',
                benchmarkType: 'Lipper Index',
                __typename: 'ETFBenchmark'
            },
            {
                benchmarkCode: 'LAMCC',
                benchmarkName: 'Lipper Mid-Cap Core Funds Average',
                benchmarkType: 'Lipper Average',
                __typename: 'ETFBenchmark'
            },
            {
                benchmarkCode: 'MSSMC',
                benchmarkName: 'MSCI USA SMID Cap Index',
                benchmarkType: 'Secondary',
                __typename: 'ETFBenchmark'
            },
            {
                benchmarkCode: 'RUS30',
                benchmarkName: 'Russell 3000 Index',
                benchmarkType: 'Regulatory',
                __typename: 'ETFBenchmark'
            }
        ],
        name: 'T. Rowe Price Small-Mid Cap ETF',
        inceptionDate: '2023-06-14T04:00:00Z',
        grossExpenseRatio: null,
        netExpenseRatio: null,
        averageAnnualTotalReturns: {
            quarterly: {
                asOfDate: '2024-12-31T00:00:00Z',
                fundPerformance: [
                    {
                        performanceType: 'Gross',
                        navMonthlyYtdReturn: 16.4,
                        navQuarterlyYtdReturn: 16.4,
                        navOneMonthReturn: -7.34,
                        navThreeMonthReturn: 0.05,
                        navSixMonthReturn: 7.34,
                        navOneYearReturn: 16.4,
                        navThreeYearAnnualizedReturn: null,
                        navFiveYearAnnualizedReturn: null,
                        navTenYearAnnualizedReturn: null,
                        navSinceInceptionReturn: 31.02,
                        navSinceInceptionAnnualizedReturn: 19.05,
                        marketPriceMonthlyYtdReturn: null,
                        marketPriceQuarterlyYtdReturn: null,
                        marketPriceOneMonthReturn: null,
                        marketPriceThreeMonthReturn: null,
                        marketPriceSixMonthReturn: null,
                        marketPriceOneYearReturn: null,
                        marketPriceThreeYearAnnualizedReturn: null,
                        marketPriceFiveYearAnnualizedReturn: null,
                        marketPriceTenYearAnnualizedReturn: null,
                        marketPriceSinceInceptionReturn: null,
                        marketPriceSinceInceptionAnnualizedReturn: null,
                        afterTaxPreLiquidMonthlyYtdReturn: null,
                        afterTaxPreLiquidQuarterlyYtdReturn: null,
                        afterTaxPreLiquidOneMonthReturn: null,
                        afterTaxPreLiquidThreeMonthReturn: null,
                        afterTaxPreLiquidSixMonthReturn: null,
                        afterTaxPreLiquidOneYearReturn: null,
                        afterTaxPreLiquidThreeYearReturn: null,
                        afterTaxPreLiquidFiveYearReturn: null,
                        afterTaxPreLiquidTenYearReturn: null,
                        afterTaxPreLiquidSinceInceptionReturn: null,
                        afterTaxPostLiquidMonthlyYtdReturn: null,
                        afterTaxPostLiquidQuarterlyYtdReturn: null,
                        afterTaxPostLiquidOneMonthReturn: null,
                        afterTaxPostLiquidThreeMonthReturn: null,
                        afterTaxPostLiquidSixMonthReturn: null,
                        afterTaxPostLiquidOneYearReturn: null,
                        afterTaxPostLiquidThreeYearReturn: null,
                        afterTaxPostLiquidFiveYearReturn: null,
                        afterTaxPostLiquidTenYearReturn: null,
                        afterTaxPostLiquidSinceInception: null,
                        __typename: 'ETFPerformance'
                    },
                    {
                        performanceType: 'Net',
                        navMonthlyYtdReturn: 15.77,
                        navQuarterlyYtdReturn: 15.77,
                        navOneMonthReturn: -7.38,
                        navThreeMonthReturn: -0.09,
                        navSixMonthReturn: 7.05,
                        navOneYearReturn: 15.77,
                        navThreeYearAnnualizedReturn: null,
                        navFiveYearAnnualizedReturn: null,
                        navTenYearAnnualizedReturn: null,
                        navSinceInceptionReturn: 29.93,
                        navSinceInceptionAnnualizedReturn: 18.41,
                        marketPriceMonthlyYtdReturn: 15.85,
                        marketPriceQuarterlyYtdReturn: 15.85,
                        marketPriceOneMonthReturn: -7.51,
                        marketPriceThreeMonthReturn: -0.21,
                        marketPriceSixMonthReturn: 7.18,
                        marketPriceOneYearReturn: 15.85,
                        marketPriceThreeYearAnnualizedReturn: null,
                        marketPriceFiveYearAnnualizedReturn: null,
                        marketPriceTenYearAnnualizedReturn: null,
                        marketPriceSinceInceptionReturn: 30.01,
                        marketPriceSinceInceptionAnnualizedReturn: 18.46,
                        afterTaxPreLiquidMonthlyYtdReturn: null,
                        afterTaxPreLiquidQuarterlyYtdReturn: null,
                        afterTaxPreLiquidOneMonthReturn: null,
                        afterTaxPreLiquidThreeMonthReturn: null,
                        afterTaxPreLiquidSixMonthReturn: null,
                        afterTaxPreLiquidOneYearReturn: null,
                        afterTaxPreLiquidThreeYearReturn: null,
                        afterTaxPreLiquidFiveYearReturn: null,
                        afterTaxPreLiquidTenYearReturn: null,
                        afterTaxPreLiquidSinceInceptionReturn: null,
                        afterTaxPostLiquidMonthlyYtdReturn: null,
                        afterTaxPostLiquidQuarterlyYtdReturn: null,
                        afterTaxPostLiquidOneMonthReturn: null,
                        afterTaxPostLiquidThreeMonthReturn: null,
                        afterTaxPostLiquidSixMonthReturn: null,
                        afterTaxPostLiquidOneYearReturn: null,
                        afterTaxPostLiquidThreeYearReturn: null,
                        afterTaxPostLiquidFiveYearReturn: null,
                        afterTaxPostLiquidTenYearReturn: null,
                        afterTaxPostLiquidSinceInception: null,
                        __typename: 'ETFPerformance'
                    }
                ],
                benchmarkPerformance: [
                    {
                        performanceType: 'Gross',
                        benchmarkCode: 'RUS25',
                        navMonthlyYtdReturn: 12,
                        navQuarterlyYtdReturn: 12,
                        navOneMonthReturn: -7.54,
                        navThreeMonthReturn: 0.62,
                        navSixMonthReturn: 9.42,
                        navOneYearReturn: 12,
                        navSinceInceptionReturn: 22.82,
                        navThreeYearAnnualizedReturn: 2.39,
                        navFiveYearAnnualizedReturn: 8.77,
                        navTenYearAnnualizedReturn: 8.85,
                        navSinceInceptionAnnualizedReturn: 14.19,
                        valueAddedMonthlyYtdReturn: 4.4,
                        valueAddedQuarterlyYtdReturn: 4.4,
                        valueAddedOneMonthReturn: 0.2,
                        valueAddedThreeMonthReturn: -0.57,
                        valueAddedSixMonthReturn: -2.08,
                        valueAddedOneYearReturn: 4.4,
                        valueAddedThreeYearAnnualizedReturn: null,
                        valueAddedFiveYearAnnualizedReturn: null,
                        valueAddedTenYearAnnualizedReturn: null,
                        valueAddedSinceInceptionReturn: 8.2,
                        valueAddedSinceInceptionAnnualizedReturn: 4.86,
                        __typename: 'ETFBenchmarkPerformance'
                    },
                    {
                        performanceType: 'Net',
                        benchmarkCode: 'RUS25',
                        navMonthlyYtdReturn: 12,
                        navQuarterlyYtdReturn: 12,
                        navOneMonthReturn: -7.54,
                        navThreeMonthReturn: 0.62,
                        navSixMonthReturn: 9.42,
                        navOneYearReturn: 12,
                        navSinceInceptionReturn: 22.82,
                        navThreeYearAnnualizedReturn: 2.39,
                        navFiveYearAnnualizedReturn: 8.77,
                        navTenYearAnnualizedReturn: 8.85,
                        navSinceInceptionAnnualizedReturn: 14.19,
                        valueAddedMonthlyYtdReturn: 3.77,
                        valueAddedQuarterlyYtdReturn: 3.77,
                        valueAddedOneMonthReturn: 0.16,
                        valueAddedThreeMonthReturn: -0.71,
                        valueAddedSixMonthReturn: -2.37,
                        valueAddedOneYearReturn: 3.77,
                        valueAddedThreeYearAnnualizedReturn: null,
                        valueAddedFiveYearAnnualizedReturn: null,
                        valueAddedTenYearAnnualizedReturn: null,
                        valueAddedSinceInceptionReturn: 7.11,
                        valueAddedSinceInceptionAnnualizedReturn: 4.22,
                        __typename: 'ETFBenchmarkPerformance'
                    },
                    {
                        performanceType: 'Gross',
                        benchmarkCode: 'LPMCC',
                        navMonthlyYtdReturn: 12.99,
                        navQuarterlyYtdReturn: 12.99,
                        navOneMonthReturn: -6.86,
                        navThreeMonthReturn: -0.83,
                        navSixMonthReturn: 8.07,
                        navOneYearReturn: 12.99,
                        navSinceInceptionReturn: 23.82,
                        navThreeYearAnnualizedReturn: 3.89,
                        navFiveYearAnnualizedReturn: 9.5,
                        navTenYearAnnualizedReturn: 8.71,
                        navSinceInceptionAnnualizedReturn: 14.79,
                        valueAddedMonthlyYtdReturn: 3.41,
                        valueAddedQuarterlyYtdReturn: 3.41,
                        valueAddedOneMonthReturn: -0.48,
                        valueAddedThreeMonthReturn: 0.88,
                        valueAddedSixMonthReturn: -0.73,
                        valueAddedOneYearReturn: 3.41,
                        valueAddedThreeYearAnnualizedReturn: null,
                        valueAddedFiveYearAnnualizedReturn: null,
                        valueAddedTenYearAnnualizedReturn: null,
                        valueAddedSinceInceptionReturn: 7.2,
                        valueAddedSinceInceptionAnnualizedReturn: 4.26,
                        __typename: 'ETFBenchmarkPerformance'
                    },
                    {
                        performanceType: 'Net',
                        benchmarkCode: 'LPMCC',
                        navMonthlyYtdReturn: 12.99,
                        navQuarterlyYtdReturn: 12.99,
                        navOneMonthReturn: -6.86,
                        navThreeMonthReturn: -0.83,
                        navSixMonthReturn: 8.07,
                        navOneYearReturn: 12.99,
                        navSinceInceptionReturn: 23.82,
                        navThreeYearAnnualizedReturn: 3.89,
                        navFiveYearAnnualizedReturn: 9.5,
                        navTenYearAnnualizedReturn: 8.71,
                        navSinceInceptionAnnualizedReturn: 14.79,
                        valueAddedMonthlyYtdReturn: 2.78,
                        valueAddedQuarterlyYtdReturn: 2.78,
                        valueAddedOneMonthReturn: -0.52,
                        valueAddedThreeMonthReturn: 0.74,
                        valueAddedSixMonthReturn: -1.02,
                        valueAddedOneYearReturn: 2.78,
                        valueAddedThreeYearAnnualizedReturn: null,
                        valueAddedFiveYearAnnualizedReturn: null,
                        valueAddedTenYearAnnualizedReturn: null,
                        valueAddedSinceInceptionReturn: 6.11,
                        valueAddedSinceInceptionAnnualizedReturn: 3.62,
                        __typename: 'ETFBenchmarkPerformance'
                    },
                    {
                        performanceType: 'Gross',
                        benchmarkCode: 'RUS30',
                        navMonthlyYtdReturn: 23.81,
                        navQuarterlyYtdReturn: 23.81,
                        navOneMonthReturn: -3.06,
                        navThreeMonthReturn: 2.63,
                        navSixMonthReturn: 9.03,
                        navOneYearReturn: 23.81,
                        navSinceInceptionReturn: null,
                        navThreeYearAnnualizedReturn: 8.01,
                        navFiveYearAnnualizedReturn: 13.86,
                        navTenYearAnnualizedReturn: 12.55,
                        navSinceInceptionAnnualizedReturn: null,
                        valueAddedMonthlyYtdReturn: -7.41,
                        valueAddedQuarterlyYtdReturn: -7.41,
                        valueAddedOneMonthReturn: -4.28,
                        valueAddedThreeMonthReturn: -2.58,
                        valueAddedSixMonthReturn: -1.69,
                        valueAddedOneYearReturn: -7.41,
                        valueAddedThreeYearAnnualizedReturn: null,
                        valueAddedFiveYearAnnualizedReturn: null,
                        valueAddedTenYearAnnualizedReturn: null,
                        valueAddedSinceInceptionReturn: null,
                        valueAddedSinceInceptionAnnualizedReturn: null,
                        __typename: 'ETFBenchmarkPerformance'
                    },
                    {
                        performanceType: 'Net',
                        benchmarkCode: 'RUS30',
                        navMonthlyYtdReturn: 23.81,
                        navQuarterlyYtdReturn: 23.81,
                        navOneMonthReturn: -3.06,
                        navThreeMonthReturn: 2.63,
                        navSixMonthReturn: 9.03,
                        navOneYearReturn: 23.81,
                        navSinceInceptionReturn: null,
                        navThreeYearAnnualizedReturn: 8.01,
                        navFiveYearAnnualizedReturn: 13.86,
                        navTenYearAnnualizedReturn: 12.55,
                        navSinceInceptionAnnualizedReturn: null,
                        valueAddedMonthlyYtdReturn: -8.04,
                        valueAddedQuarterlyYtdReturn: -8.04,
                        valueAddedOneMonthReturn: -4.32,
                        valueAddedThreeMonthReturn: -2.72,
                        valueAddedSixMonthReturn: -1.98,
                        valueAddedOneYearReturn: -8.04,
                        valueAddedThreeYearAnnualizedReturn: null,
                        valueAddedFiveYearAnnualizedReturn: null,
                        valueAddedTenYearAnnualizedReturn: null,
                        valueAddedSinceInceptionReturn: null,
                        valueAddedSinceInceptionAnnualizedReturn: null,
                        __typename: 'ETFBenchmarkPerformance'
                    },
                    {
                        performanceType: 'Gross',
                        benchmarkCode: 'MSSMC',
                        navMonthlyYtdReturn: 13.82,
                        navQuarterlyYtdReturn: 13.82,
                        navOneMonthReturn: -7.43,
                        navThreeMonthReturn: 0.4,
                        navSixMonthReturn: 9.99,
                        navOneYearReturn: 13.82,
                        navSinceInceptionReturn: 25.15,
                        navThreeYearAnnualizedReturn: 3.02,
                        navFiveYearAnnualizedReturn: 9.98,
                        navTenYearAnnualizedReturn: 9.66,
                        navSinceInceptionAnnualizedReturn: 15.58,
                        valueAddedMonthlyYtdReturn: 2.58,
                        valueAddedQuarterlyYtdReturn: 2.58,
                        valueAddedOneMonthReturn: 0.09,
                        valueAddedThreeMonthReturn: -0.35,
                        valueAddedSixMonthReturn: -2.65,
                        valueAddedOneYearReturn: 2.58,
                        valueAddedThreeYearAnnualizedReturn: null,
                        valueAddedFiveYearAnnualizedReturn: null,
                        valueAddedTenYearAnnualizedReturn: null,
                        valueAddedSinceInceptionReturn: 5.87,
                        valueAddedSinceInceptionAnnualizedReturn: 3.47,
                        __typename: 'ETFBenchmarkPerformance'
                    },
                    {
                        performanceType: 'Net',
                        benchmarkCode: 'MSSMC',
                        navMonthlyYtdReturn: 13.82,
                        navQuarterlyYtdReturn: 13.82,
                        navOneMonthReturn: -7.43,
                        navThreeMonthReturn: 0.4,
                        navSixMonthReturn: 9.99,
                        navOneYearReturn: 13.82,
                        navSinceInceptionReturn: 25.15,
                        navThreeYearAnnualizedReturn: 3.02,
                        navFiveYearAnnualizedReturn: 9.98,
                        navTenYearAnnualizedReturn: 9.66,
                        navSinceInceptionAnnualizedReturn: 15.58,
                        valueAddedMonthlyYtdReturn: 1.95,
                        valueAddedQuarterlyYtdReturn: 1.95,
                        valueAddedOneMonthReturn: 0.05,
                        valueAddedThreeMonthReturn: -0.49,
                        valueAddedSixMonthReturn: -2.94,
                        valueAddedOneYearReturn: 1.95,
                        valueAddedThreeYearAnnualizedReturn: null,
                        valueAddedFiveYearAnnualizedReturn: null,
                        valueAddedTenYearAnnualizedReturn: null,
                        valueAddedSinceInceptionReturn: 4.78,
                        valueAddedSinceInceptionAnnualizedReturn: 2.83,
                        __typename: 'ETFBenchmarkPerformance'
                    }
                ],
                __typename: 'AverageAnnualTotalReturn'
            },
            monthly: {
                asOfDate: '2024-12-31T00:00:00Z',
                fundPerformance: [
                    {
                        performanceType: 'Gross',
                        navMonthlyYtdReturn: 16.4,
                        navQuarterlyYtdReturn: 16.4,
                        navOneMonthReturn: -7.34,
                        navThreeMonthReturn: 0.05,
                        navSixMonthReturn: 7.34,
                        navOneYearReturn: 16.4,
                        navThreeYearAnnualizedReturn: null,
                        navFiveYearAnnualizedReturn: null,
                        navTenYearAnnualizedReturn: null,
                        navSinceInceptionReturn: 31.02,
                        navSinceInceptionAnnualizedReturn: 19.05,
                        marketPriceMonthlyYtdReturn: null,
                        marketPriceQuarterlyYtdReturn: null,
                        marketPriceOneMonthReturn: null,
                        marketPriceThreeMonthReturn: null,
                        marketPriceSixMonthReturn: null,
                        marketPriceOneYearReturn: null,
                        marketPriceThreeYearAnnualizedReturn: null,
                        marketPriceFiveYearAnnualizedReturn: null,
                        marketPriceTenYearAnnualizedReturn: null,
                        marketPriceSinceInceptionReturn: null,
                        marketPriceSinceInceptionAnnualizedReturn: null,
                        afterTaxPreLiquidMonthlyYtdReturn: null,
                        afterTaxPreLiquidQuarterlyYtdReturn: null,
                        afterTaxPreLiquidOneMonthReturn: null,
                        afterTaxPreLiquidThreeMonthReturn: null,
                        afterTaxPreLiquidSixMonthReturn: null,
                        afterTaxPreLiquidOneYearReturn: null,
                        afterTaxPreLiquidThreeYearReturn: null,
                        afterTaxPreLiquidFiveYearReturn: null,
                        afterTaxPreLiquidTenYearReturn: null,
                        afterTaxPreLiquidSinceInceptionReturn: null,
                        afterTaxPostLiquidMonthlyYtdReturn: null,
                        afterTaxPostLiquidQuarterlyYtdReturn: null,
                        afterTaxPostLiquidOneMonthReturn: null,
                        afterTaxPostLiquidThreeMonthReturn: null,
                        afterTaxPostLiquidSixMonthReturn: null,
                        afterTaxPostLiquidOneYearReturn: null,
                        afterTaxPostLiquidThreeYearReturn: null,
                        afterTaxPostLiquidFiveYearReturn: null,
                        afterTaxPostLiquidTenYearReturn: null,
                        afterTaxPostLiquidSinceInception: null,
                        __typename: 'ETFPerformance'
                    },
                    {
                        performanceType: 'Net',
                        navMonthlyYtdReturn: 15.77,
                        navQuarterlyYtdReturn: 15.77,
                        navOneMonthReturn: -7.38,
                        navThreeMonthReturn: -0.09,
                        navSixMonthReturn: 7.05,
                        navOneYearReturn: 15.77,
                        navThreeYearAnnualizedReturn: null,
                        navFiveYearAnnualizedReturn: null,
                        navTenYearAnnualizedReturn: null,
                        navSinceInceptionReturn: 29.93,
                        navSinceInceptionAnnualizedReturn: 18.41,
                        marketPriceMonthlyYtdReturn: 15.85,
                        marketPriceQuarterlyYtdReturn: 15.85,
                        marketPriceOneMonthReturn: -7.51,
                        marketPriceThreeMonthReturn: -0.21,
                        marketPriceSixMonthReturn: 7.18,
                        marketPriceOneYearReturn: 15.85,
                        marketPriceThreeYearAnnualizedReturn: null,
                        marketPriceFiveYearAnnualizedReturn: null,
                        marketPriceTenYearAnnualizedReturn: null,
                        marketPriceSinceInceptionReturn: 30.01,
                        marketPriceSinceInceptionAnnualizedReturn: 18.46,
                        afterTaxPreLiquidMonthlyYtdReturn: null,
                        afterTaxPreLiquidQuarterlyYtdReturn: null,
                        afterTaxPreLiquidOneMonthReturn: null,
                        afterTaxPreLiquidThreeMonthReturn: null,
                        afterTaxPreLiquidSixMonthReturn: null,
                        afterTaxPreLiquidOneYearReturn: null,
                        afterTaxPreLiquidThreeYearReturn: null,
                        afterTaxPreLiquidFiveYearReturn: null,
                        afterTaxPreLiquidTenYearReturn: null,
                        afterTaxPreLiquidSinceInceptionReturn: null,
                        afterTaxPostLiquidMonthlyYtdReturn: null,
                        afterTaxPostLiquidQuarterlyYtdReturn: null,
                        afterTaxPostLiquidOneMonthReturn: null,
                        afterTaxPostLiquidThreeMonthReturn: null,
                        afterTaxPostLiquidSixMonthReturn: null,
                        afterTaxPostLiquidOneYearReturn: null,
                        afterTaxPostLiquidThreeYearReturn: null,
                        afterTaxPostLiquidFiveYearReturn: null,
                        afterTaxPostLiquidTenYearReturn: null,
                        afterTaxPostLiquidSinceInception: null,
                        __typename: 'ETFPerformance'
                    }
                ],
                benchmarkPerformance: [
                    {
                        performanceType: 'Gross',
                        benchmarkCode: 'RUS25',
                        navMonthlyYtdReturn: 12,
                        navQuarterlyYtdReturn: 12,
                        navOneMonthReturn: -7.54,
                        navThreeMonthReturn: 0.62,
                        navSixMonthReturn: 9.42,
                        navOneYearReturn: 12,
                        navThreeYearAnnualizedReturn: 2.39,
                        navFiveYearAnnualizedReturn: 8.77,
                        navTenYearAnnualizedReturn: 8.85,
                        navSinceInceptionReturn: 22.82,
                        navSinceInceptionAnnualizedReturn: 14.19,
                        valueAddedMonthlyYtdReturn: 4.4,
                        valueAddedQuarterlyYtdReturn: 4.4,
                        valueAddedOneMonthReturn: 0.2,
                        valueAddedThreeMonthReturn: -0.57,
                        valueAddedSixMonthReturn: -2.08,
                        valueAddedOneYearReturn: 4.4,
                        valueAddedThreeYearAnnualizedReturn: null,
                        valueAddedFiveYearAnnualizedReturn: null,
                        valueAddedTenYearAnnualizedReturn: null,
                        valueAddedSinceInceptionReturn: 8.2,
                        valueAddedSinceInceptionAnnualizedReturn: 4.86,
                        __typename: 'ETFBenchmarkPerformance'
                    },
                    {
                        performanceType: 'Net',
                        benchmarkCode: 'RUS25',
                        navMonthlyYtdReturn: 12,
                        navQuarterlyYtdReturn: 12,
                        navOneMonthReturn: -7.54,
                        navThreeMonthReturn: 0.62,
                        navSixMonthReturn: 9.42,
                        navOneYearReturn: 12,
                        navThreeYearAnnualizedReturn: 2.39,
                        navFiveYearAnnualizedReturn: 8.77,
                        navTenYearAnnualizedReturn: 8.85,
                        navSinceInceptionReturn: 22.82,
                        navSinceInceptionAnnualizedReturn: 14.19,
                        valueAddedMonthlyYtdReturn: 3.77,
                        valueAddedQuarterlyYtdReturn: 3.77,
                        valueAddedOneMonthReturn: 0.16,
                        valueAddedThreeMonthReturn: -0.71,
                        valueAddedSixMonthReturn: -2.37,
                        valueAddedOneYearReturn: 3.77,
                        valueAddedThreeYearAnnualizedReturn: null,
                        valueAddedFiveYearAnnualizedReturn: null,
                        valueAddedTenYearAnnualizedReturn: null,
                        valueAddedSinceInceptionReturn: 7.11,
                        valueAddedSinceInceptionAnnualizedReturn: 4.22,
                        __typename: 'ETFBenchmarkPerformance'
                    },
                    {
                        performanceType: 'Gross',
                        benchmarkCode: 'LPMCC',
                        navMonthlyYtdReturn: 12.99,
                        navQuarterlyYtdReturn: 12.99,
                        navOneMonthReturn: -6.86,
                        navThreeMonthReturn: -0.83,
                        navSixMonthReturn: 8.07,
                        navOneYearReturn: 12.99,
                        navThreeYearAnnualizedReturn: 3.89,
                        navFiveYearAnnualizedReturn: 9.5,
                        navTenYearAnnualizedReturn: 8.71,
                        navSinceInceptionReturn: 23.82,
                        navSinceInceptionAnnualizedReturn: 14.79,
                        valueAddedMonthlyYtdReturn: 3.41,
                        valueAddedQuarterlyYtdReturn: 3.41,
                        valueAddedOneMonthReturn: -0.48,
                        valueAddedThreeMonthReturn: 0.88,
                        valueAddedSixMonthReturn: -0.73,
                        valueAddedOneYearReturn: 3.41,
                        valueAddedThreeYearAnnualizedReturn: null,
                        valueAddedFiveYearAnnualizedReturn: null,
                        valueAddedTenYearAnnualizedReturn: null,
                        valueAddedSinceInceptionReturn: 7.2,
                        valueAddedSinceInceptionAnnualizedReturn: 4.26,
                        __typename: 'ETFBenchmarkPerformance'
                    },
                    {
                        performanceType: 'Net',
                        benchmarkCode: 'LPMCC',
                        navMonthlyYtdReturn: 12.99,
                        navQuarterlyYtdReturn: 12.99,
                        navOneMonthReturn: -6.86,
                        navThreeMonthReturn: -0.83,
                        navSixMonthReturn: 8.07,
                        navOneYearReturn: 12.99,
                        navThreeYearAnnualizedReturn: 3.89,
                        navFiveYearAnnualizedReturn: 9.5,
                        navTenYearAnnualizedReturn: 8.71,
                        navSinceInceptionReturn: 23.82,
                        navSinceInceptionAnnualizedReturn: 14.79,
                        valueAddedMonthlyYtdReturn: 2.78,
                        valueAddedQuarterlyYtdReturn: 2.78,
                        valueAddedOneMonthReturn: -0.52,
                        valueAddedThreeMonthReturn: 0.74,
                        valueAddedSixMonthReturn: -1.02,
                        valueAddedOneYearReturn: 2.78,
                        valueAddedThreeYearAnnualizedReturn: null,
                        valueAddedFiveYearAnnualizedReturn: null,
                        valueAddedTenYearAnnualizedReturn: null,
                        valueAddedSinceInceptionReturn: 6.11,
                        valueAddedSinceInceptionAnnualizedReturn: 3.62,
                        __typename: 'ETFBenchmarkPerformance'
                    },
                    {
                        performanceType: 'Gross',
                        benchmarkCode: 'RUS30',
                        navMonthlyYtdReturn: 23.81,
                        navQuarterlyYtdReturn: 23.81,
                        navOneMonthReturn: -3.06,
                        navThreeMonthReturn: 2.63,
                        navSixMonthReturn: 9.03,
                        navOneYearReturn: 23.81,
                        navThreeYearAnnualizedReturn: 8.01,
                        navFiveYearAnnualizedReturn: 13.86,
                        navTenYearAnnualizedReturn: 12.55,
                        navSinceInceptionReturn: null,
                        navSinceInceptionAnnualizedReturn: null,
                        valueAddedMonthlyYtdReturn: -7.41,
                        valueAddedQuarterlyYtdReturn: -7.41,
                        valueAddedOneMonthReturn: -4.28,
                        valueAddedThreeMonthReturn: -2.58,
                        valueAddedSixMonthReturn: -1.69,
                        valueAddedOneYearReturn: -7.41,
                        valueAddedThreeYearAnnualizedReturn: null,
                        valueAddedFiveYearAnnualizedReturn: null,
                        valueAddedTenYearAnnualizedReturn: null,
                        valueAddedSinceInceptionReturn: null,
                        valueAddedSinceInceptionAnnualizedReturn: null,
                        __typename: 'ETFBenchmarkPerformance'
                    },
                    {
                        performanceType: 'Net',
                        benchmarkCode: 'RUS30',
                        navMonthlyYtdReturn: 23.81,
                        navQuarterlyYtdReturn: 23.81,
                        navOneMonthReturn: -3.06,
                        navThreeMonthReturn: 2.63,
                        navSixMonthReturn: 9.03,
                        navOneYearReturn: 23.81,
                        navThreeYearAnnualizedReturn: 8.01,
                        navFiveYearAnnualizedReturn: 13.86,
                        navTenYearAnnualizedReturn: 12.55,
                        navSinceInceptionReturn: null,
                        navSinceInceptionAnnualizedReturn: null,
                        valueAddedMonthlyYtdReturn: -8.04,
                        valueAddedQuarterlyYtdReturn: -8.04,
                        valueAddedOneMonthReturn: -4.32,
                        valueAddedThreeMonthReturn: -2.72,
                        valueAddedSixMonthReturn: -1.98,
                        valueAddedOneYearReturn: -8.04,
                        valueAddedThreeYearAnnualizedReturn: null,
                        valueAddedFiveYearAnnualizedReturn: null,
                        valueAddedTenYearAnnualizedReturn: null,
                        valueAddedSinceInceptionReturn: null,
                        valueAddedSinceInceptionAnnualizedReturn: null,
                        __typename: 'ETFBenchmarkPerformance'
                    },
                    {
                        performanceType: 'Gross',
                        benchmarkCode: 'MSSMC',
                        navMonthlyYtdReturn: 13.82,
                        navQuarterlyYtdReturn: 13.82,
                        navOneMonthReturn: -7.43,
                        navThreeMonthReturn: 0.4,
                        navSixMonthReturn: 9.99,
                        navOneYearReturn: 13.82,
                        navThreeYearAnnualizedReturn: 3.02,
                        navFiveYearAnnualizedReturn: 9.98,
                        navTenYearAnnualizedReturn: 9.66,
                        navSinceInceptionReturn: 25.15,
                        navSinceInceptionAnnualizedReturn: 15.58,
                        valueAddedMonthlyYtdReturn: 2.58,
                        valueAddedQuarterlyYtdReturn: 2.58,
                        valueAddedOneMonthReturn: 0.09,
                        valueAddedThreeMonthReturn: -0.35,
                        valueAddedSixMonthReturn: -2.65,
                        valueAddedOneYearReturn: 2.58,
                        valueAddedThreeYearAnnualizedReturn: null,
                        valueAddedFiveYearAnnualizedReturn: null,
                        valueAddedTenYearAnnualizedReturn: null,
                        valueAddedSinceInceptionReturn: 5.87,
                        valueAddedSinceInceptionAnnualizedReturn: 3.47,
                        __typename: 'ETFBenchmarkPerformance'
                    },
                    {
                        performanceType: 'Net',
                        benchmarkCode: 'MSSMC',
                        navMonthlyYtdReturn: 13.82,
                        navQuarterlyYtdReturn: 13.82,
                        navOneMonthReturn: -7.43,
                        navThreeMonthReturn: 0.4,
                        navSixMonthReturn: 9.99,
                        navOneYearReturn: 13.82,
                        navThreeYearAnnualizedReturn: 3.02,
                        navFiveYearAnnualizedReturn: 9.98,
                        navTenYearAnnualizedReturn: 9.66,
                        navSinceInceptionReturn: 25.15,
                        navSinceInceptionAnnualizedReturn: 15.58,
                        valueAddedMonthlyYtdReturn: 1.95,
                        valueAddedQuarterlyYtdReturn: 1.95,
                        valueAddedOneMonthReturn: 0.05,
                        valueAddedThreeMonthReturn: -0.49,
                        valueAddedSixMonthReturn: -2.94,
                        valueAddedOneYearReturn: 1.95,
                        valueAddedThreeYearAnnualizedReturn: null,
                        valueAddedFiveYearAnnualizedReturn: null,
                        valueAddedTenYearAnnualizedReturn: null,
                        valueAddedSinceInceptionReturn: 4.78,
                        valueAddedSinceInceptionAnnualizedReturn: 2.83,
                        __typename: 'ETFBenchmarkPerformance'
                    }
                ],
                __typename: 'AverageAnnualTotalReturn'
            },
            daily: {
                asOfDate: '2025-03-12T00:00:00Z',
                fundPerformance: [
                    {
                        performanceType: null,
                        navDailyYtdReturn: -6.39,
                        marketPriceDailyYtdReturn: -6.6,
                        __typename: 'ETFDailyPerformance'
                    }
                ],
                benchmarkPerformance: [],
                __typename: 'AverageAnnualTotalReturnDaily'
            },
            __typename: 'AverageAnnualTotalReturns'
        },
        __typename: 'ExchangeTradedFund'
    }
};

export const ETFMarketDataMock = {
    exchangeTradedFund: {
        inavTicker: null,
        inceptionDate: '2021-09-28T04:00:00Z',
        transparencyTypeName: 'Fully Transparent',
        averageAnnualTotalReturns: {
            quarterly: {
                asOfDate: null, // "2023-03-31T00:00:00Z",
                __typename: 'AverageAnnualTotalReturn'
            },
            __typename: 'AverageAnnualTotalReturns'
        },
        price: {
            asOfDate: '2023-06-02T00:00:00Z',
            navPrice: 40.95,
            navPricePercentChange: -0.53437,
            closingPrice: 41.05,
            closingPricePercentChange: -0.557171,
            outstandingShares: 700000,
            premiumDiscountValuePercent: 0.2442,
            totalAssets: 28666230.33,
            dailyTradingVolumeShares: 2063,
            __typename: 'ETFPrice'
        },
        __typename: 'ExchangeTradedFund'
    }
};

export const ETFPremiumDaysMock = {
    exchangeTradedFund: {
        name: 'T. Rowe Price Intermediate Municipal Income ETF',
        shortName: 'Intermediate Municipal Income ETF',
        inceptionDate: '2024-07-09T04:00:00Z',
        premiumDiscount: {
            asOfDate: '2024-07-03T00:00:00Z',
            previousYear: null,
            daysTradedAtPremiumInPreviousYear: null,
            daysTradedAtDiscountInPreviousYear: null,
            currentYear: '2024',
            daysTradedAtPremiumInCurrentYearQ1: null,
            daysTradedAtPremiumInCurrentYearQ2: '1',
            daysTradedAtPremiumInCurrentYearQ3: null,
            daysTradedAtPremiumInCurrentYearQ4: null,
            daysTradedAtDiscountInCurrentYearQ1: null,
            daysTradedAtDiscountInCurrentYearQ2: '2',
            daysTradedAtDiscountInCurrentYearQ3: null,
            daysTradedAtDiscountInCurrentYearQ4: null,
            premiumDiscountData: [
                {
                    asOfDate: '2024-06-18T00:00:00Z',
                    premiumDiscountValueBPS: -10.296,
                    __typename: 'ETFPremiumDiscountData'
                },
                {
                    asOfDate: '2024-06-20T00:00:00Z',
                    premiumDiscountValueBPS: 2.59,
                    __typename: 'ETFPremiumDiscountData'
                },
                {
                    asOfDate: '2024-06-21T00:00:00Z',
                    premiumDiscountValueBPS: -5.1867,
                    __typename: 'ETFPremiumDiscountData'
                },
                {
                    asOfDate: '2024-06-24T00:00:00Z',
                    premiumDiscountValueBPS: 0,
                    __typename: 'ETFPremiumDiscountData'
                },
                {
                    asOfDate: '2024-06-25T00:00:00Z',
                    premiumDiscountValueBPS: 0,
                    __typename: 'ETFPremiumDiscountData'
                },
                {
                    asOfDate: '2024-06-26T00:00:00Z',
                    premiumDiscountValueBPS: 0,
                    __typename: 'ETFPremiumDiscountData'
                },
                {
                    asOfDate: '2024-06-27T00:00:00Z',
                    premiumDiscountValueBPS: 0,
                    __typename: 'ETFPremiumDiscountData'
                }
            ],
            __typename: 'ETFPremiumDiscount'
        },
        __typename: 'ExchangeTradedFund'
    }
};

export const MonthlyDistributionMock = {
    exchangeTradedFund: {
        // averageAnnualTotalReturns: null,
        averageAnnualTotalReturns: {
            quarterly: {
                asOfDate: '2024-12-31T00:00:00Z'
            }
        },
        thirtyDaySECDividend: 6.74,
        thirtyDaySECDividendAsOfDate: '2025-01-31T00:00:00Z',
        unsubsidizedThirtyDaySECYield: 6.74,
        unsubsidizedThirtyDaySECYieldAsOfDate: '2025-01-31T00:00:00Z',
        // distribution: null,
        distribution: {
            distributionFrequency: 'Monthly',
            distributions: [
                {
                    exDate: '2023-11-13T00:00:00Z',
                    totalDistribution: 0.0601
                },
                {
                    exDate: '2025-01-31T00:00:00Z',
                    totalDistribution: 1.1898874
                },
                {
                    exDate: '2023-12-20T00:00:00Z',
                    totalDistribution: 0.0705
                },
                {
                    exDate: '2025-02-13T00:00:00Z',
                    totalDistribution: 0.164
                }
            ]
        },
        distributionMetrics: {
            asOfDate: '2025-01-31T00:00:00Z',
            distMetricsData: [
                {
                    distributionRate: 1.968,
                    distributionAmount: 0.164,
                    twelveMonthTrailingDistributionRate: 1.9731999999999998,
                    rateDate: '2025-02-03T00:00:00Z'
                }
            ]
        }
    }
};

export const ETFInvestmentObjectiveFundManagerMock = {
    exchangeTradedFund: {
        mutualFundManagers: [
            {
                managerID: 0,
                managerName: 'Taymour Tamaddon, CFA',
                title: 'Test Manager',
                managedFundSinceDate: '2023-06-14T00:00:00Z',
                joinedFirmDate: '2004-05-19T00:00:00Z',
                headShots2: [
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/TAMADDON_Taymour:1x1-Jumbo',
                        width: 384,
                        height: 384,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/TAMADDON_Taymour:1x1-Normal',
                        width: 128,
                        height: 128,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/TAMADDON_Taymour:1x1-Mini',
                        width: 64,
                        height: 64,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/TAMADDON_Taymour:2x3-Normal',
                        width: 256,
                        height: 384,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/TAMADDON_Taymour:1x1-Non_Beacon-(96x96)',
                        width: 96,
                        height: 96,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/TAMADDON_Taymour:1x1-Bio-ID-card-normal',
                        width: 50,
                        height: 50,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/TAMADDON_Taymour:1x1-Maxi-Standalone-ID-card',
                        width: 160,
                        height: 160,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/TAMADDON_Taymour:2-3-Hero-Horizontal-BioCard-medium',
                        width: 312,
                        height: 468,
                        __typename: 'FundManagerHeadShot'
                    }
                ],
                __typename: 'FundManager'
            },
            {
                managerID: 0,
                managerName: 'Donald Peters',
                title: 'Co-Portfolio Manager',
                managedFundSinceDate: '2023-06-14T00:00:00Z',
                joinedFirmDate: '1993-06-01T00:00:00Z',
                headShots2: [
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/PETERS_Don:1x1-Jumbo',
                        width: 384,
                        height: 384,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/PETERS_Don:1x1-Normal',
                        width: 128,
                        height: 128,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/PETERS_Don:1x1-Mini',
                        width: 64,
                        height: 64,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/PETERS_Don:2x3-Normal',
                        width: 256,
                        height: 384,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/PETERS_Don:1x1-Non_Beacon-(96x96)',
                        width: 96,
                        height: 96,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/PETERS_Don:1x1-Bio-ID-card-normal',
                        width: 50,
                        height: 50,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/PETERS_Don:1x1-Maxi-Standalone-ID-card',
                        width: 160,
                        height: 160,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/PETERS_Don:2-3-Hero-Horizontal-BioCard-medium',
                        width: 312,
                        height: 468,
                        __typename: 'FundManagerHeadShot'
                    }
                ],
                __typename: 'FundManager'
            },
            {
                managerID: 0,
                managerName: 'Jodi Love',
                title: 'Portfolio Manager',
                managedFundSinceDate: '2023-06-14T00:00:00Z',
                joinedFirmDate: '2019-09-16T00:00:00Z',
                headShots2: [
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/LOVE_Jodi:1x1-Jumbo',
                        width: 384,
                        height: 384,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/LOVE_Jodi:1x1-Normal',
                        width: 128,
                        height: 128,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/LOVE_Jodi:1x1-Mini',
                        width: 64,
                        height: 64,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/LOVE_Jodi:2x3-Normal',
                        width: 256,
                        height: 384,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/LOVE_Jodi:1x1-Non_Beacon-(96x96)',
                        width: 96,
                        height: 96,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/LOVE_Jodi:1x1-Bio-ID-card-normal',
                        width: 50,
                        height: 50,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/LOVE_Jodi:1x1-Maxi-Standalone-ID-card',
                        width: 160,
                        height: 160,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/LOVE_Jodi:2-3-Hero-Horizontal-BioCard-medium',
                        width: 312,
                        height: 468,
                        __typename: 'FundManagerHeadShot'
                    }
                ],
                __typename: 'FundManager'
            }
        ],
        __typename: 'ExchangeTradedFund'
    }
};

export const ETFInvestmentTeamFundManagerMock = {
    exchangeTradedFund: {
        mutualFundManagers: [
            {
                managerID: 0,
                educationText:
                    'B.S., Cornell University; M.B.A., Tuck School of Business at Dartmouth',
                managerName: 'Taymour Tamaddon, CFA',
                title: 'Test Manager',
                managedFundSinceDate: '2023-06-14T00:00:00Z',
                joinedFirmDate: '2004-05-19T00:00:00Z',
                headShots2: [
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/TAMADDON_Taymour:1x1-Jumbo',
                        width: 384,
                        height: 384,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/TAMADDON_Taymour:1x1-Normal',
                        width: 128,
                        height: 128,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/TAMADDON_Taymour:1x1-Mini',
                        width: 64,
                        height: 64,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/TAMADDON_Taymour:2x3-Normal',
                        width: 256,
                        height: 384,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/TAMADDON_Taymour:1x1-Non_Beacon-(96x96)',
                        width: 96,
                        height: 96,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/TAMADDON_Taymour:1x1-Bio-ID-card-normal',
                        width: 50,
                        height: 50,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/TAMADDON_Taymour:1x1-Maxi-Standalone-ID-card',
                        width: 160,
                        height: 160,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/TAMADDON_Taymour:2-3-Hero-Horizontal-BioCard-medium',
                        width: 312,
                        height: 468,
                        __typename: 'FundManagerHeadShot'
                    }
                ],
                __typename: 'FundManager'
            },
            {
                managerID: 0,
                educationText:
                    'M.B.A., Wharton School, University of Pennsylvania; B.A., summa cum laude, Tulane University',
                managerName: 'Donald Peters',
                title: 'Co-Portfolio Manager',
                managedFundSinceDate: '2023-06-14T00:00:00Z',
                joinedFirmDate: '1993-06-01T00:00:00Z',
                headShots2: [
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/PETERS_Don:1x1-Jumbo',
                        width: 384,
                        height: 384,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/PETERS_Don:1x1-Normal',
                        width: 128,
                        height: 128,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/PETERS_Don:1x1-Mini',
                        width: 64,
                        height: 64,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/PETERS_Don:2x3-Normal',
                        width: 256,
                        height: 384,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/PETERS_Don:1x1-Non_Beacon-(96x96)',
                        width: 96,
                        height: 96,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/PETERS_Don:1x1-Bio-ID-card-normal',
                        width: 50,
                        height: 50,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/PETERS_Don:1x1-Maxi-Standalone-ID-card',
                        width: 160,
                        height: 160,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/PETERS_Don:2-3-Hero-Horizontal-BioCard-medium',
                        width: 312,
                        height: 468,
                        __typename: 'FundManagerHeadShot'
                    }
                ],
                __typename: 'FundManager'
            },
            {
                managerID: 0,
                educationText: null,
                managerName: 'Jodi Love',
                title: 'Portfolio Manager',
                managedFundSinceDate: '2023-06-14T00:00:00Z',
                joinedFirmDate: '2019-09-16T00:00:00Z',
                headShots2: [
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/LOVE_Jodi:1x1-Jumbo',
                        width: 384,
                        height: 384,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/LOVE_Jodi:1x1-Normal',
                        width: 128,
                        height: 128,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/LOVE_Jodi:1x1-Mini',
                        width: 64,
                        height: 64,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/LOVE_Jodi:2x3-Normal',
                        width: 256,
                        height: 384,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/LOVE_Jodi:1x1-Non_Beacon-(96x96)',
                        width: 96,
                        height: 96,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/LOVE_Jodi:1x1-Bio-ID-card-normal',
                        width: 50,
                        height: 50,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/LOVE_Jodi:1x1-Maxi-Standalone-ID-card',
                        width: 160,
                        height: 160,
                        __typename: 'FundManagerHeadShot'
                    },
                    {
                        path:
                            'https://dynamicmedia.troweprice.com/is/image/trowepriceassociatesincstage/LOVE_Jodi:2-3-Hero-Horizontal-BioCard-medium',
                        width: 312,
                        height: 468,
                        __typename: 'FundManagerHeadShot'
                    }
                ],
                __typename: 'FundManager'
            }
        ],
        __typename: 'ExchangeTradedFund'
    }
};
